const RevenueReporting = {
  CreateRevenueReport: "RevenueReporting.CreateRevenueReport",
  SubmitRevenueReport: "RevenueReporting.SubmitRevenueReport",
  Submit: "RevenueReporting.Submit",
  CreatedRevenueReport: "RevenueReporting.CreatedRevenueReport",
  RevenueDate: "RevenueReporting.RevenueDate",
  PaymentMethodSelect: "RevenueReporting.PaymentMethodSelect",
  Other: "RevenueReporting.Other",
  Difference: "RevenueReporting.Difference",
  DifferenceBetweenSums: "RevenueReporting.DifferenceBetweenSums",
  SelectTemplate: "RevenueReporting.SelectTemplate",
  TagsHelpText: "RevenueReporting.TagsHelpText",
  AddTags: "RevenueReporting.AddTags",
  ChangeTags: "RevenueReporting.ChangeTags",
  EditTags: "RevenueReporting.EditTags",
  WholeReport: "RevenueReporting.WholeReport",
  AttachmentsHelpText: "RevenueReporting.AttachmentsHelpText",
  AttachmentRequired: "RevenueReporting.AttachmentRequired",
  DifferenceWarningTitle: "RevenueReporting.DifferenceWarningTitle",
  DifferenceWarningText: "RevenueReporting.DifferenceWarningText",
  SelectPaymentMethodInfo: "RevenueReporting.SelectPaymentMethodInfo",
  Reports: "RevenueReporting.Reports",
  PaymentMethod: "RevenueReporting.PaymentMethod",
  StatusReported: "RevenueReporting.StatusReported",
  StatusVoided: "RevenueReporting.StatusVoided",
  ApprovalTodoHeader: "RevenueReporting.ApprovalTodoHeader",
  ApprovalTodoSubHeader: "RevenueReporting.ApprovalTodoSubHeader",
  AddReport: "RevenueReporting.AddReport",
  ReportNoIncome: "RevenueReporting.ReportNoIncome",
  CommentLabel: "RevenueReporting.CommentLabel",
  CommentHelpText: "RevenueReporting.CommentHelpText",
  CommentPlaceholder: "RevenueReporting.CommentPlaceholder",
  SupplementaryMaterial: "RevenueReporting.SupplementaryMaterial",
  SupplementaryMaterialHelpText: "RevenueReporting.SupplementaryMaterialHelpText",
  PreviousPeriodUnapprovedWarning: "RevenueReporting.PreviousPeriodUnapprovedWarning",
  ApproveTodoSuccessMessage: "RevenueReporting.ApproveTodoSuccessMessage",
  HideLegacyReports: "RevenueReporting.HideLegacyReports",
  ListTruncated: "RevenueReporting.ListTruncated",
  NoActivePaymentMethods: "RevenueReporting.NoActivePaymentMethods",
  }
export default RevenueReporting;